function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "backgroundrect",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0,
  fill: "none",
  stroke: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Layer 1");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "svg_1",
  className: "",
  fill: "#ffffff",
  fillOpacity: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "svg_2",
  fill: "currentColor",
  fillOpacity: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M506.134,241.843c-0.006-0.006-0.011-0.013-0.018-0.019l-104.504-104c-7.829-7.791-20.492-7.762-28.285,0.068    c-7.792,7.829-7.762,20.492,0.067,28.284L443.558,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h423.557    l-70.162,69.824c-7.829,7.792-7.859,20.455-0.067,28.284c7.793,7.831,20.457,7.858,28.285,0.068l104.504-104    c0.006-0.006,0.011-0.013,0.018-0.019C513.968,262.339,513.943,249.635,506.134,241.843z",
  id: "svg_3",
  fill: "#ffffff",
  fillOpacity: 1
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "svg_4"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "svg_5"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "svg_6"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "svg_7"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "svg_8"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "svg_9"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "svg_10"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "svg_11"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "svg_12"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "svg_13"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  id: "svg_14"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  id: "svg_15"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  id: "svg_16"
});

var _ref18 = /*#__PURE__*/React.createElement("g", {
  id: "svg_17"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "svg_18"
});

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.0b211a17.svg";
export { ForwardRef as ReactComponent };